import api from '@/client/core/api'
import {
  PostInstagramInstantwinPrizeData,
  PostInstagramInstantwinPrizeParams
} from '@/typings/api/instagram_instantwin_prizes.schema'

type PostInstagramInstantwinPrizeApiResponse = {
  data?: PostInstagramInstantwinPrizeData
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class PostInstagramInstantwinPrizeApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

/**
 * Instagram インスタントウィン応募グループを新規作成
 *
 * @param params - 作成パラメータ
 * @returns 作成された応募グループID
 */
export async function postInstagramInstantwinPrize(
  params: PostInstagramInstantwinPrizeParams
): Promise<PostInstagramInstantwinPrizeData> {
  const response = await api.post<PostInstagramInstantwinPrizeApiResponse>('/instagram_instantwin_prizes', params)

  if (response instanceof Error) {
    throw response
  }

  if (response?.error?.type) {
    throw new PostInstagramInstantwinPrizeApiError(response.error.type, response.error.message, response.error.status)
  }

  if (!response?.data) {
    throw new PostInstagramInstantwinPrizeApiError(
      'INVALID_RESPONSE',
      '応募グループ作成APIのレスポンス形式が不正です。'
    )
  }

  return response.data
}
